(() => {
    const loadMoreBtn = document.getElementById("load-more");
    if (loadMoreBtn) loadMoreFunction();

    function loadMoreFunction() {
        const currentUrl = new URL(window.location.href);
        const urlPath = currentUrl.origin + currentUrl.pathname;
        const listCount = parseInt(loadMoreBtn.getAttribute("data-list-count"));

        loadMoreBtn.addEventListener("click", async () => {
            const appendCount = parseInt(loadMoreBtn.getAttribute("data-append-count"));
            const pageSize = parseInt(loadMoreBtn.getAttribute("data-pagesize"));
            const pageSizeNumber = parseInt(loadMoreBtn.getAttribute("data-page-size-number"));
       
            const after = pageSize + pageSizeNumber;

            try {
                const response = await fetch(`${urlPath}?after=${after}`);

                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                const data = await response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, "text/html");
                let newArticles = doc.querySelectorAll("[data-list-item]");
                if (newArticles.length > appendCount) {
                    newArticles = Array.from(newArticles).slice(0, appendCount);
                }

                const articlesContainer = document.querySelector("[data-list-container]");
                newArticles.forEach((article) => {
                    manipulateArticle(article);
                    articlesContainer.appendChild(article);
                });

                const articlesShown = document.querySelectorAll("[data-list-container] [data-list-item]").length;

                if (newArticles.length < appendCount || articlesShown >= listCount) {
                    loadMoreBtn.style.display = "none";
                    return;
                }

                loadMoreBtn.setAttribute("data-pagesize", articlesShown);
            } catch (error) {
                console.error("Error loading more articles:", error);
            }
        });

        function manipulateArticle(article) {
            article.className = article.className.replace("featured", "");
        }
    }
})();
